import { Component, Input } from '@angular/core';
import { PocketbaseService } from '../../services/pocketbase.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SocialLoginComponent } from "../social-login/social-login.component";
import { ClientResponseError } from 'pocketbase';

const DEFAULT_LOGIN_FAILURE_MESSAGE = 'Login Fehlgeschlagen.';

@Component({
    selector: 'app-login',
    imports: [CommonModule, ReactiveFormsModule, RouterLink, SocialLoginComponent],
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss'
})
export class LoginComponent {
  loginForm: FormGroup;
  loginFailureMessage = DEFAULT_LOGIN_FAILURE_MESSAGE;
  showPasswordReset = false;

  readonly returnUrl: string;

  @Input()
  set token(token: string) {
    if (token) {
      this.verificationState = 'loading';

      this.pocketbaseService.pb.collection('users').confirmVerification(token).then(() => {
        this.verificationState = 'success';

        if (this.pocketbaseService.loggedIn()) {
          // user is already logged in, navigate to start page (or returnUrl)
          this.router.navigateByUrl(this.returnUrl);
          // (otherwise stay on login page)
        }

      }).catch(() => {
        this.verificationState = 'error';
      })
    }
  }

  verificationState: 'loading' | 'success' | 'error' | undefined;


  model = { email: '', password: '' };
  submitted = false;
  manualLoginFailed = false;
  passwordResetTriggered = false;

  constructor(
    private readonly pocketbaseService: PocketbaseService,
    private readonly router: Router,
    private readonly fb: FormBuilder,
    private readonly route: ActivatedRoute
  ) {
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/';

    if (pocketbaseService.loggedIn() && pocketbaseService.pb.authStore.model != null) {
      // could display this to the user if we wanted to
      console.warn(`already logged in as ${pocketbaseService.pb.authStore.model['email']}`);
    }

    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  async onSubmit() {
    if (this.loginForm.valid) {
      this.submitted = true;
      this.manualLoginFailed = false;
      this.showPasswordReset = false;
      this.loginFailureMessage = DEFAULT_LOGIN_FAILURE_MESSAGE;

      const email = this.loginForm.get('email')?.value;
      const password = this.loginForm.get('password')?.value;

      this.pocketbaseService.login(email, password).then(() => {
        this.router.navigateByUrl(this.returnUrl);
      }).catch((e: ClientResponseError) => {
        console.log(e.status);
      if (e.status === 403) {
          // not verified
          this.manualLoginFailed = true;
          this.pocketbaseService.pb.collection('users').requestVerification(email).then(() => {
            this.loginFailureMessage = 'Du musst erst deine E-Mail bestätigen, bevor du dich einloggen kannst. Wir haben dir den Link zur Verifizierung soeben erneut zugesendet.'
          })
        } else {
          this.manualLoginFailed = true;
          this.showPasswordReset = true;
        }
      });
    }
  }

  resetPassword() {
    const email = this.loginForm.get('email')?.value;

    this.passwordResetTriggered = true;
    this.pocketbaseService.pb.collection('users').requestPasswordReset(email)
      .then()
      .catch();
  }
}
